import tokenManager from "../utils/tokenManager";

export const useRoles = () => {
  return tokenManager.getUserData()?.roles;
};

export default useRoles;
